import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/** Must stay in sync with backend HexIdentifierValidator.PERIPHERAL_ID_PATTERN. */
export const PERIPHERAL_ID_PATTERN = /^[0-9A-Fa-f]{12}$/;

/** Must stay in sync with backend HexIdentifierValidator.MAC_ADDRESS_PATTERN. */
export const MAC_ADDRESS_PATTERN =
  /^(?:(?:[0-9A-Fa-f]{2}[:-]){5}[0-9A-Fa-f]{2}|[0-9A-Fa-f]{12})$/;

export const PERIPHERAL_ID_REQUIRED_MESSAGE = 'Peripheral ID is required.';

export const PERIPHERAL_ID_INVALID_MESSAGE =
  'Peripheral ID must be exactly 12 hexadecimal characters (0–9 and A–F).';

export const MAC_ADDRESS_INVALID_MESSAGE =
  'MAC address must contain only hexadecimal characters (0–9 and A–F).';

export const PERIPHERAL_ID_HINT =
  'Use 12 hexadecimal characters (0–9 and A–F).';

export function peripheralIdValidator(
  control: AbstractControl
): ValidationErrors | null {
  const raw = control.value;
  if (raw == null || String(raw).trim() === '') {
    return { required: true };
  }
  if (!PERIPHERAL_ID_PATTERN.test(String(raw).trim())) {
    return { hexadecimal: true };
  }
  return null;
}

export function macAddressValidator(
  control: AbstractControl
): ValidationErrors | null {
  const raw = control.value;
  if (raw == null || String(raw).trim() === '') {
    return null;
  }
  if (!MAC_ADDRESS_PATTERN.test(String(raw).trim())) {
    return { hexadecimal: true };
  }
  return null;
}

export function getPeripheralIdValidators(): ValidatorFn[] {
  return [peripheralIdValidator];
}

export function getPeripheralIdErrorMessage(
  errors: Record<string, unknown> | null | undefined
): string {
  if (!errors) {
    return '';
  }
  if (errors['required']) {
    return PERIPHERAL_ID_REQUIRED_MESSAGE;
  }
  if (errors['hexadecimal'] || errors['pattern']) {
    return PERIPHERAL_ID_INVALID_MESSAGE;
  }
  return PERIPHERAL_ID_INVALID_MESSAGE;
}

export function getMacAddressErrorMessage(
  errors: Record<string, unknown> | null | undefined
): string {
  if (!errors) {
    return '';
  }
  if (errors['hexadecimal'] || errors['pattern']) {
    return MAC_ADDRESS_INVALID_MESSAGE;
  }
  return MAC_ADDRESS_INVALID_MESSAGE;
}
